import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LockComponent } from "./lock.component";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LockComponent
    ],
    exports: [
        LockComponent
    ]
})
export class LockModule { }